:host {
    --wcs-dropdown-divider-margin: var(--wcs-semantic-spacing-base) 0;
    --wcs-dropdown-divider-color: var(--wcs-semantic-color-border-secondary);

    display: block;
    margin: var(--wcs-dropdown-divider-margin);
    overflow: hidden;
    border-top: 1px solid var(--wcs-dropdown-divider-color);
}
